import type { Exercise, MediaType } from './types';

export interface ExerciseMedia {
  type: MediaType;
  url?: string;
  provider: string;
  attribution?: string;
  fallbackLabel: string;
}

/** Keeps workout programming independent from whichever licensed media source is used. */
export interface ExerciseMediaProvider {
  getMedia(exercise: Exercise): ExerciseMedia;
}

export const defaultExerciseMediaProvider: ExerciseMediaProvider = {
  getMedia: (exercise) => ({
    type: exercise.mediaType,
    url: exercise.mediaUrl,
    provider: exercise.mediaProvider,
    attribution: exercise.mediaAttribution,
    fallbackLabel: `${exercise.primaryMuscle} demonstration`
  })
};
